module.exports = __webpack_public_path__ + "static/img/protein03.3601117.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/images/protein03.png
// module id = Flc8
// module chunks = 0